module.exports = __webpack_public_path__ + "static/selling_software_background-2ddf73aa9deb7086c5dc6ede5034bde5.svg";